<template>
    <form @submit="checkForm" method="post">


        <the-title parentcolor="orange">
            <slot slot="de">Anmeldung</slot>
            <slot slot="en">Registration</slot>
        </the-title>

        <div v-if="!send">

            <div v-if="firstpage">
                <div class="my-8">
                    <inputcomponent type="text" name="contact" placeholder_de="Anprechpartner"
                                    placeholder_en="contact person"/>
                </div>
                <div class="my-8">
                    <inputcomponent type="text" name="telefon" placeholder_de="Telefon" placeholder_en="Telephone"/>
                </div>
                <div class="my-8">
                    <inputcomponent type="email" name="email" placeholder_de="E-Mail" placeholder_en="E-Mail"/>
                </div>
                <div class="my-8">
                    <inputcomponent type="text" name="organisation" placeholder_de="Organisation"
                                    placeholder_en="organization"/>
                </div>
                <div class="my-8">
                    <inputcomponent type="text" name="stadt" placeholder_de="Stadt" placeholder_en="city"/>
                </div>
                <div class="my-8">
                    <inputcomponent type="text" name="country" placeholder_de="Land" placeholder_en="country"/>
                </div>

                <formular-title>
                    <slot slot="de">Anzahl der Sportler*Innen</slot>
                    <slot slot="en">Number of athletes</slot>
                </formular-title>

                <div class="grid grid-columns-2">
                    <inputcomponent type="number" name="teilnehmer_w" placeholder_de="weiblich" placeholder_en="female"/>
                    <inputcomponent type="number" name="teilnehmer_m" placeholder_de="männlich" placeholder_en="male"/>
                </div>

                <formular-title>
                    <slot slot="de">Anzahl der Betreuer*Innen</slot>
                    <slot slot="en">Number of supervisors</slot>
                </formular-title>

                <div class="grid grid-columns-2">
                    <inputcomponent type="number" name="betreuer_w" placeholder_de="weiblich" placeholder_en="femail"/>
                    <inputcomponent type="number" name="betreuer_m" placeholder_de="männlich" placeholder_en="male"/>
                </div>

                <formular-title>
                    <slot slot="de">Anreisemittel</slot>
                    <slot slot="en">transportation</slot>
                </formular-title>

                <ul>
                    <li class="text-sm leading-loose pt-3 mt-5 text-primary-orange span-inline-block">
                        <label class="checkbox">
                            <input type="checkbox" name="anreise" value="bus" v-model="anreise">
                            <the-language de="Bus" en="bus" />
                        </label>
                    </li>
                    <li class="text-sm leading-loose pt-3 mt-5 text-primary-orange span-inline-block">
                        <label class="checkbox">
                            <input type="checkbox" name="anreise" value="Flugzeug" v-model="anreise">
                            <the-language de="Flugzeug" en="airplane" />
                        </label>
                    </li>
                    <li class="text-sm leading-loose pt-3 mt-5 text-primary-orange span-inline-block">
                        <label class="checkbox">
                            <input type="checkbox" name="anreise" value="Bahn" v-model="anreise">
                            <the-language de="Bahn" en="train" />
                        </label>
                    </li>
                </ul>


                <div v-if="errors.length">
                    <ul class="text-primary-red">
                        <li class="lang-de mb-3" v-for="error in errors">{{ error }}</li>
                        <li class="lang-en mb-3" v-for="error_en in errors_en">{{ error_en }}</li>
                    </ul>
                </div>

                <the-button @click.native="nextStep">
                    <the-language de="weiter" en="next step" />
                </the-button>

            </div>



            <div v-if="secondpage">
                <formular-title>
                    <slot slot="de">Sportarten auswählen:</slot>
                    <slot slot="en">Select sports</slot>
                </formular-title>
                <ul>
                    <li v-for="sportItems in sports" :key="sportItems.ID" class="text-sm leading-loose pt-3 mt-5 text-primary-orange">
                        <label class="checkbox">
                            <input type="checkbox" name="sportart" v-bind:value="sportItems.formvalue" v-model="sportsChecked">
                            <the-language :de="sportItems.sportart_de + '-' + sportItems.altersklasse_de" :en="sportItems.sportart_en + '-' + sportItems.altersklasse_en" />
                        </label>
                    </li>
                </ul>



                <the-submit>
                    <the-button>
                        <the-language de="Anmelden" en="Register" />
                    </the-button>
                </the-submit>
            </div>


        </div>


        <div v-if="send">
            <the-language de="Vielen Dank für Ihre Anmeldung" en="Thank you very much for your registration"/>
        </div>


    </form>
</template>

<script>
    import {serverBus} from '../../main';
    import inputcomponent from './input'
    import formularTitle from './formularTitle'
    import TheTitle from '../TheTitle'
    import TheButton from '../TheButton'
    import TheLanguage from "../TheLanguage";
    import TheSubmit from "../TheSubmit";

    export default {
        name: 'formular',
        data() {
            return {
                errors: [],
                errors_en: [],
                teilnehmer_m: null,
                teilnehmer_w: null,
                betreuer_m: null,
                betreuer_w: null,
                geistliche: null,
                contact: null,
                email: null,
                telefon: null,
                organisation: null,
                country: null,
                send: false,
                sports: [],
                sportsChecked: [],
                anreise: [],
                firstpage: true,
                secondpage: false
            }
        },
        components: {
            inputcomponent,
            formularTitle,
            TheTitle,
            TheButton,
            TheLanguage,
            TheSubmit
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/sports.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.sports = result.data
                })

            // Using the server bus
            serverBus.$on('teilnehmer_m', (teilnehmer_m) => {
                this.teilnehmer_m = teilnehmer_m;
            }),
            serverBus.$on('teilnehmer_w', (teilnehmer_w) => {
                this.teilnehmer_w = teilnehmer_w;
            }),
            serverBus.$on('betreuer_m', (betreuer_m) => {
                this.betreuer_m = betreuer_m;
            }),
            serverBus.$on('geistliche', (geistliche) => {
                this.geistliche = geistliche;
            }),
            serverBus.$on('betreuer_w', (betreuer_w) => {
                this.betreuer_w = betreuer_w;
            }),
            serverBus.$on('betreuer_w', (betreuer_w) => {
                this.betreuer_w = betreuer_w;
            }),
            serverBus.$on('contact', (contact) => {
                this.contact = contact;
            }),
            serverBus.$on('email', (email) => {
                this.email = email;
            }),
            serverBus.$on('telefon', (telefon) => {
                this.telefon = telefon;
            }),
            serverBus.$on('organisation', (organisation) => {
                this.organisation = organisation;
            }),
            serverBus.$on('country', (country) => {
                this.country = country;
            })
            serverBus.$on('stadt', (stadt) => {
                this.stadt = stadt;
            })



        },
        methods: {
                nextStep(){
                    this.errors = [];
                    this.errors_en = [];

                    if(!this.teilnehmer_m){
                        this.errors.push("Bitte angeben: Wie viele männliche Teilnehmer werden erwartet?");
                        this.errors_en.push("Please specify: How many male participants are expected?");
                    }
                    if(!this.teilnehmer_w){
                        this.errors.push("Bitte angeben: Wie viele weibliche Teilnehmer werden erwartet?");
                        this.errors_en.push("Please specify: How many female participants are expected?");
                    }
                    if(!this.betreuer_m){
                        this.errors.push("Bitte angeben: Wie viele männliche Betreuer werden erwartet?");
                        this.errors_en.push("Please specify: How many male carers are expected??");
                    }
                    if(!this.betreuer_w){
                        this.errors.push("Bitte angeben: Wie viele weibliche Betreuer werden erwartet?");
                        this.errors_en.push("Please specify: How many female carers are expected??");
                    }
                    /*if(!this.geistliche){
                        this.errors.push("Bitte angeben: Wie viele Geistliche werden erwartet?");
                        this.errors_en.push("Please specify: How many priests are expected??");
                    }*/
                    if(!this.contact){
                        this.errors.push("Bitte einen Ansprechpartenr angeben");
                        this.errors_en.push("Please specify a contact person");
                    }
                    if(!this.email){
                        this.errors.push("Bitte eine E-Mail Adresse angeben");
                        this.errors_en.push("Please enter your e-mail address");
                    }
                    if(!this.telefon){
                        this.errors.push("Bitte eine Telefon Nummer angeben");
                        this.errors_en.push("Please enter your telephone number");
                    }
                    if(!this.organisation){
                        this.errors.push("Bitte den Namen der Organisation angeben!");
                        this.errors_en.push("Please indicate the name of the organisation!");
                    }
                    if(!this.country){
                        this.errors.push("Bitte das Heimatland angeben");
                        this.errors_en.push("Please indicate your home country");
                    }
                    if(!this.stadt){
                        this.errors.push("Bitte den Namen der Stadt angeben");
                        this.errors_en.push("Please enter the name of the city");
                    }



                    if(this.errors.length === 0){
                        this.firstpage = false;
                        this.secondpage = true;
                    }

                },
                checkForm: function (e) {
                this.errors = [];
                /*if(!this.name){
                    this.errors.push("Keine Name.");
                }
                if(!this.email){
                    this.errors.push("Keine E-Mail Adresse");
                }*/

                if (this.errors.length) {
                    e.preventDefault();
                } else {
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", 'https://api.pgsi2020.de/api/mail/mail.php', true);

                    //Send the proper header information along with the request
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

                    xhr.onreadystatechange = function () { // Call a function when the state changes.
                        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                            // Request finished. Do processing here.
                        }
                    }
                    xhr.send('teilnehmer_m=' + this.teilnehmer_m
                        + '&teilnehmer_w=' + this.teilnehmer_w
                        + '&betreuer_m=' + this.betreuer_m
                        + '&betreuer_w=' + this.betreuer_w
                        + '&contact=' + this.contact
                        + '&email=' + this.email
                        + '&organisation=' + this.organisation
                        + '&country=' + this.country
                        + '&stadt=' + this.stadt
                        + '&geistliche=' + this.geistliche
                        + '&sports=' + this.sportsChecked
                        + '&anreise=' + this.anreise
                    );

                    this.send = true;

                    window.scrollTo(0,0);



                    e.preventDefault();
                }

            }
        }
    }

</script>

<style>

    .checkbox{
        z-index: 0;
        position: relative;
        display: inline-block;
    }
    .checkbox > input{
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        z-index: -1;
        position: absolute;
        left: -10px;
        top: -8px;
        display: block;
        margin: 0;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        background-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
        box-shadow: none;
        outline: none;
        opacity: 0;
        transform: scale(1);
        pointer-events: none;
        transition: opacity 0.3s, transform 0.2s;
    }
    .checkbox > span{
        width: 100%;
        cursor: pointer;
    }


    .checkbox > span::before {
        content: "";
        display: inline-block;
        box-sizing: border-box;
        margin: 3px 11px 3px 1px;
        border: solid 2px; /* Safari */
        border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
        border-radius: 2px;
        width: 18px;
        height: 18px;
        vertical-align: top;
        transition: border-color 0.2s, background-color 0.2s;
    }

    /* Checkmark */
    .checkbox > span::after {
        content: "";
        display: block;
        position: absolute;
        top: 3px;
        left: 1px;
        width: 10px;
        height: 5px;
        border: solid 2px transparent;
        border-right: none;
        border-top: none;
        transform: translate(3px, 4px) rotate(-45deg);
    }

    /* Checked, Indeterminate */
    .checkbox > input:checked,
    .checkbox > input:indeterminate {
        @apply bg-primary-orange;
    }

    .checkbox > input:checked + span::before,
    .checkbox > input:indeterminate + span::before {
        @apply bg-primary-orange border-primary-orange;
    }

    .checkbox > input:checked + span::after,
    .checkbox > input:indeterminate + span::after {
        border-color: white;
    }

    .checkbox > input:indeterminate + span::after {
        border-left: none;
        transform: translate(4px, 3px);
    }

    /* Hover, Focus */
    .checkbox:hover > input {
        opacity: 0.04;
    }

    .checkbox > input:focus {
        opacity: 0.12;
    }

    .checkbox:hover > input:focus {
        opacity: 0.16;
    }

    /* Active */
    .checkbox > input:active {
        opacity: 1;
        transform: scale(0);
        transition: transform 0s, opacity 0s;
    }

    .checkbox > input:active + span::before {
        //border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
    }

    .checkbox > input:checked:active + span::before {
        border-color: transparent;
        background-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
    }

    /* Disabled */
    .checkbox > input:disabled {
        opacity: 0;
    }

    .checkbox > input:disabled + span {
        color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.38);
        cursor: initial;
    }

    .checkbox > input:disabled + span::before {
        border-color: currentColor;
    }

    .checkbox > input:checked:disabled + span::before,
    .checkbox > input:indeterminate:disabled + span::before {
        border-color: transparent;
        background-color: currentColor;
    }

</style>





